export const OFFICE_UPDATE = 'OFFICE_UPDATE';
export const OFFICE_CLEAR_ALL = 'OFFICE_CLEAR_ALL';



// WEBPACK FOOTER //
// ./src/constants/offices.js